import instance from "api/apiClient";

export interface Segment {
  id: number;
  title: string;
  description?: string;
  isActive?: boolean;
  type: string;
  countOfUsers: number;
}

export interface SegmentPayload {
  limit?: number;
  offset?: number;
  isActive?: 1 | 0;
  title?: string;
  segmentIds?: number[];
  order?: {
    title: "asc" | "desc";
  };
}

export const getSegmentsListService = async (
  payload: SegmentPayload
): Promise<Segment[]> => {
  const response = await instance.post("/segment/list", payload);
  return response.data?.items ?? [];
};
